import useCurrency from '@/composables/useCurrency'

export default function StringMethods() {
	const stripUnderScore = (arg: string): string => {
		return arg ? arg.replace(/_/g, ' ') : arg
	}

	const replaceDummyPrice = (characters: string, With?: unknown): string => {
		const { format } = useCurrency()
		const price = `<span class='font-bold'>${format(Number(With))}</span>`
		return characters.replace('mcg_price', price)
	}
	const toNumber = (chars: string | number) => {
		return parseInt((chars as string).replace(/,/g, ''), 10)
	}
	const replacePlaceholder = (info: string, item: string): string => {
		return info.replace('$', `<span class="text-primary-2 ">${item}</span>`)
	}
	const stringGenerator = (e?: number) => {
		if (typeof e !== 'number') {
			return String(Math.random() * 100)
		}
		const max = e
		const chars = 'abcdefghijklmnopqrstuvwxyz123456789'
		let i = ''
		const charLength = chars.length
		for (let index = 0; index < max; index++) {
			i += chars.charAt(Math.floor(Math.random() * charLength))
		}
		return i
	}
	const toCapitalize = (arg: string) => {
		return arg.charAt(0).toUpperCase() + arg.slice(1).toLowerCase()
	}
	const convertNumberToText = (n: number): string => {
		const num =
			'zero one two three four five six seven eight nine ten eleven twelve thirteen fourteen fifteen sixteen seventeen eighteen nineteen'.split(
				' '
			)
		const tens = 'twenty thirty forty fifty sixty seventy eighty ninety'.split(' ')
		if (n < 20) {
			return num[n] ?? ''
		}
		const digit = n % 10
		if (n < 100) {
			return (tens[~~(n / 10) - 2] ?? '') + (digit ? '-' + (num[digit] ?? '') : '')
		}
		if (n < 1000) {
			return (num[~~(n / 100)] ?? '') + ' hundred' + (n % 100 === 0 ? '' : ' and ' + convertNumberToText(n % 100))
		}
		if (n < 1000000) {
			return (
				convertNumberToText(~~(n / 1000)) +
				' thousand' +
				(n % 1000 !== 0 ? ' ' + convertNumberToText(n % 1000) : '')
			)
		}
		if (n < 1000000000) {
			return (
				convertNumberToText(~~(n / 1000000)) +
				' million' +
				(n % 1000000 !== 0 ? ' ' + convertNumberToText(n % 1000000) : '')
			)
		}
		if (n < 1000000000000) {
			return (
				convertNumberToText(~~(n / 1000000000)) +
				' billion' +
				(n % 1000000000 !== 0 ? ' ' + convertNumberToText(n % 1000000000) : '')
			)
		}
		return (
			convertNumberToText(~~(n / 1000000000000)) +
			' billion' +
			(n % 1000000000000 !== 0 ? ' ' + convertNumberToText(n % 1000000000000) : '')
		)
	}
	const addUnderScore = (arg: string, all = true) => {
		if (all) {
			return String(arg).replace(/ /g, '_')
		}
		return String(arg).replace(/ /, '_')
	}
	const getRandomElement = (arr: string[]) => {
		return arr[Math.floor(Math.random() * arr.length)]
	}
	const generateBusinessName = () => {
		const adjectives = [
			'Global',
			'Innovative',
			'Creative',
			'Dynamic',
			'Visionary',
			'Advanced',
			'Modern',
			'Elite',
			'Prime',
			'NextGen'
		]

		const nouns = [
			'Solutions',
			'Technologies',
			'Consulting',
			'Designs',
			'Ventures',
			'Enterprises',
			'Concepts',
			'Systems',
			'Networks',
			'Holdings'
		]

		const suffixes = ['Inc', 'LLC', 'Ltd', 'Corp', 'Group', 'Associates', 'Partners', 'Co']

		const adjective = getRandomElement(adjectives)
		const noun = getRandomElement(nouns)
		const suffix = getRandomElement(suffixes)

		return `${adjective} ${noun} ${suffix}`
	}
	const toLower = (arg: unknown) => {
		return String(arg).toLowerCase()
	}

	const generatePersonName = () => {
		const firstNames = [
			'James',
			'Mary',
			'John',
			'Patricia',
			'Robert',
			'Jennifer',
			'Michael',
			'Linda',
			'William',
			'Elizabeth',
			'David',
			'Barbara',
			'Richard',
			'Susan',
			'Joseph',
			'Jessica',
			'Thomas',
			'Sarah',
			'Charles',
			'Karen',
			'Christopher',
			'Nancy',
			'Daniel',
			'Margaret',
			'Matthew',
			'Lisa',
			'Anthony',
			'Betty',
			'Mark',
			'Dorothy',
			'Donald',
			'Sandra',
			'Paul',
			'Ashley',
			'Steven',
			'Kimberly',
			'Andrew',
			'Donna',
			'Joshua',
			'Emily'
		]

		const lastNames = [
			'Smith',
			'Johnson',
			'Williams',
			'Brown',
			'Jones',
			'Garcia',
			'Miller',
			'Davis',
			'Rodriguez',
			'Martinez',
			'Hernandez',
			'Lopez',
			'Gonzalez',
			'Wilson',
			'Anderson',
			'Thomas',
			'Taylor',
			'Moore',
			'Jackson',
			'Martin',
			'Lee',
			'Perez',
			'Thompson',
			'White',
			'Harris',
			'Sanchez',
			'Clark',
			'Ramirez',
			'Lewis',
			'Robinson',
			'Walker',
			'Young',
			'Allen',
			'King',
			'Wright',
			'Scott',
			'Torres',
			'Nguyen',
			'Hill',
			'Flores'
		]

		const firstName = getRandomElement(firstNames)
		const lastName = getRandomElement(lastNames)

		return `${firstName} ${lastName}`
	}
	const generateRandomPhoneNumber = (length = 11) => {
		const prefix = '0808'
		const remainingLength = length - prefix.length
		let phoneNumber = prefix

		for (let i = 0; i < remainingLength; i++) {
			const randomDigit = Math.floor(Math.random() * 10)
			phoneNumber += randomDigit
		}

		return phoneNumber
	}
	return {
		toLower,
		generateBusinessName,
		generateRandomPhoneNumber,
		generatePersonName,
		stripUnderScore,
		replaceDummyPrice,
		getRandomElement,
		replacePlaceholder,
		toNumber,
		stringGenerator,
		convertNumberToText,
		toCapitalize,
		addUnderScore
	}
}

/**
 * @template T
 */
export class GroupObject<T extends Record<string, unknown> = Record<string, unknown>> {
	private object: T[]
	/**
	 * @param {T[]} array
	 */
	constructor(array: T[]) {
		this.object = array
	}

	/**
	 * @param {string} key
	 * @returns {Record<string, T[]>}
	 */
	groupBy(key: keyof T & string): Record<string, T[]> {
		return this.object.reduce((groups: Record<string, T[]>, item: T) => {
			const groupKey = String(item[key])

			if (!groups[groupKey]) {
				groups[groupKey] = []
			}

			groups[groupKey].push(item)

			return groups
		}, {})
	}
}
